import { runDemo } from "../shared/demoRunner";
import { createDofScene } from "./scene";

runDemo({ createScene: createDofScene });
